/*eslint-disable*/
import React, { useContext, useState } from "react";

// Create a context to share modal results
export const ModalResultContext = React.createContext();

// Custom hook to manage modal state and results
export const useShareModal = () => {
    const [modalState, setModalState] = useState({
        visible: false,
        item: null,
        result: null,
    });

    const showModal = (item) => {
        setModalState({
            visible: true,
            item,
            result: null,
        });
    };

    const hideModal = (result = null) => {
        setModalState(prev => ({
            ...prev,
            visible: false,
            result: result !== null ? result : prev.result,
        }));
    };

    return {
        modalVisible: modalState.visible,
        modalItem: modalState.item,
        modalResult: modalState.result,
        showModal,
        hideModal,
        clearResult: () => setModalState(prev => ({ ...prev, result: null })),
    };
};

const ShareListingBrochureModalWebApp = ({
    modalVisible,
    hideModal,
    item,
    selectedOption,
    setSelectedOption,
    generatePDF
}) => {

    const handleOptionSelect = (option) => {
        setSelectedOption(option);

        // Handle the selected option
        switch (option) {
            case 'address':
                if (generatePDF && item) {
                    generatePDF(item);
                }
                break;
            case 'suburb':
                // Handle suburb sharing logic
                break;
            default:
                break;
        }

        // Hide modal and pass the result
        hideModal(option);
    };

    const handleClose = () => {
        setSelectedOption(null);
        hideModal('cancelled');
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    // If modal is not visible, don't render anything
    if (!modalVisible) return null;

    // Inline styles
    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            padding: '20px',
        },
        centeredView: {
            width: '100%',
            maxWidth: '500px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        modalContainer: {
            width: '100%',
            backgroundColor: '#fff',
            borderRadius: '5px',
            border: '1px solid #e0e0e0',
            padding: '24px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            maxWidth: '400px',
        },
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
        },
        modalTitle: {
            fontSize: '22px',
            fontWeight: 700,
            color: '#000',
            flex: 1,
            margin: 0,
        },
        closeButton: {
            background: 'none',
            border: 'none',
            padding: '8px',
            marginLeft: '8px',
            cursor: 'pointer',
            color: '#666',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        modalSubtitle: {
            fontSize: '16px',
            color: '#666',
            marginBottom: '24px',
            textAlign: 'center',
        },
        optionsContainer: {
            marginBottom: '24px',
        },
        optionButton: {
            width: '100%',
            backgroundColor: '#fff',
            border: '2px solid #e0e0e0',
            borderRadius: '10px',
            padding: '20px',
            marginBottom: '12px',
            minHeight: '100px',
            textAlign: 'left',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
        },
        optionButtonSelected: {
            backgroundColor: '#007AFF',
            borderColor: '#007AFF',
        },
        optionContent: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
        },
        optionIcon: {
            marginRight: '12px',
        },
        optionText: {
            fontSize: '18px',
            fontWeight: 600,
            color: '#000',
            flex: 1,
        },
        optionTextSelected: {
            color: '#fff',
        },
        optionDescription: {
            fontSize: '14px',
            color: '#666',
            lineHeight: '20px',
            paddingLeft: '34px',
            margin: 0,
        },
        optionDescriptionSelected: {
            color: 'rgba(255, 255, 255, 0.9)',
        },
        footer: {
            borderTop: '1px solid #e0e0e0',
            paddingTop: '20px',
        },
        cancelButton: {
            width: '100%',
            background: 'none',
            border: 'none',
            padding: '14px 24px',
            cursor: 'pointer',
        },
        cancelButtonText: {
            fontSize: '16px',
            color: '#666',
            fontWeight: 600,
        },
        svgIcon: {
            display: 'inline-block',
            verticalAlign: 'middle',
        }
    };

    return (
        <div
            style={styles.overlay}
            onClick={handleOverlayClick}
        >
            <div style={styles.centeredView}>
                <div style={styles.modalContainer}>
                    <div style={styles.modalHeader}>
                        <h2 style={styles.modalTitle}>Share Location</h2>
                        <button
                            style={styles.closeButton}
                            onClick={handleClose}
                            aria-label="Close modal"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                style={styles.svgIcon}
                            >
                                <path d="M18 6L6 18M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <p style={styles.modalSubtitle}>Share this listing as:</p>

                    <div style={styles.optionsContainer}>
                        <button
                            style={{
                                ...styles.optionButton,
                                ...(selectedOption === 'address' && styles.optionButtonSelected)
                            }}
                            onClick={() => handleOptionSelect('address')}
                        >
                            <div style={styles.optionContent}>
                                <svg
                                    style={styles.optionIcon}
                                    width="22"
                                    height="22"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke={selectedOption === 'address' ? '#fff' : '#007AFF'}
                                    strokeWidth="2"
                                >
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                    <circle cx="12" cy="10" r="3" />
                                </svg>
                                <span style={{
                                    ...styles.optionText,
                                    ...(selectedOption === 'address' && styles.optionTextSelected)
                                }}>
                                    Full Address
                                </span>
                            </div>
                            <p style={{
                                ...styles.optionDescription,
                                ...(selectedOption === 'address' && styles.optionDescriptionSelected)
                            }}>
                                {item?.address?.address || "Not specified"}
                            </p>
                        </button>

                        <button
                            style={{
                                ...styles.optionButton,
                                ...(selectedOption === 'suburb' && styles.optionButtonSelected)
                            }}
                            onClick={() => handleOptionSelect('suburb')}
                        >
                            <div style={styles.optionContent}>
                                <svg
                                    style={styles.optionIcon}
                                    width="22"
                                    height="22"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke={selectedOption === 'suburb' ? '#fff' : '#007AFF'}
                                    strokeWidth="2"
                                >
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                    <line x1="3" y1="9" x2="21" y2="9" />
                                    <line x1="9" y1="21" x2="9" y2="9" />
                                </svg>
                                <span style={{
                                    ...styles.optionText,
                                    ...(selectedOption === 'suburb' && styles.optionTextSelected)
                                }}>
                                    Suburb Only
                                </span>
                            </div>
                            <p style={{
                                ...styles.optionDescription,
                                ...(selectedOption === 'suburb' && styles.optionDescriptionSelected)
                            }}>
                                {item?.address?.suburb || "Not specified"}
                            </p>
                        </button>
                    </div>

                    <div style={styles.footer}>
                        <button
                            style={styles.cancelButton}
                            onClick={handleClose}
                        >
                            <span style={styles.cancelButtonText}>Cancel</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareListingBrochureModalWebApp;